import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-eeb3f6a2")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("button", {
    class: ['items-center justify-center', _ctx.centerButton, _ctx.flexButton +
		 'cursor-pointer bg-white ' +
		  ' font-bold rounded-full   ' +
		   'shadow-lg focus:outline-none focus:shadow-outline ' +
		    'transform transition hover:scale-105 duration-300 ease-in-out break-all' +
		     'text-button1 text-white dark:text-gray-900 font-medium default-btn', _ctx.buttonXMargin, _ctx.buttonXPadding, _ctx.buttonYPadding, _ctx.buttonHover, _ctx.buttonColor, _ctx.textColor, _ctx.buttonWidth, _ctx.customCss, _ctx.buttonDisabled ? 'disabled:opacity-50' : ''],
    type: _ctx.buttonType,
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickButton && _ctx.clickButton(...args))),
    disabled: _ctx.buttonDisabled
  }, _toDisplayString(_ctx.buttonText), 11, ["type", "disabled"]))
})